import { useStore } from '../../../store';

export const useBankAccountsStore = () => {
    const { bankAccounts } = useStore();
    return bankAccounts;
};
